"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var type_1 = require("../type");
var utils_1 = require("../../utils");
var core_1 = require("../../core");
var type_checker_1 = require("../type-checker");
var Refinement = (function (_super) {
    __extends(Refinement, _super);
    function Refinement(name, type, predicate) {
        var _this = _super.call(this, name) || this;
        _this.type = type;
        _this.predicate = predicate;
        return _this;
    }
    Refinement.prototype.describe = function () {
        return this.name;
    };
    Refinement.prototype.create = function (value) {
        // create the child type
        var inst = this.type.create(value);
        var snapshot = core_1.isMST(inst) ? core_1.getMSTAdministration(inst).snapshot : inst;
        // check if pass the predicate
        utils_1.invariant(this.is(snapshot), "Value " + JSON.stringify(snapshot) + " is not assignable to type " + this.name);
        return inst;
    };
    Refinement.prototype.validate = function (value, context) {
        if (this.type.is(value) && this.predicate(value)) {
            return type_checker_1.typeCheckSuccess();
        }
        return type_checker_1.typeCheckFailure(context, value);
    };
    Object.defineProperty(Refinement.prototype, "identifierAttribute", {
        get: function () {
            return this.type.identifierAttribute;
        },
        enumerable: true,
        configurable: true
    });
    return Refinement;
}(type_1.Type));
exports.Refinement = Refinement;
function refinement(name, type, predicate) {
    // check if the subtype default value passes the predicate
    var inst = type.create();
    utils_1.invariant(predicate(core_1.isMST(inst) ? core_1.getMSTAdministration(inst).snapshot : inst), "Default value for refinement type " + name + " does not pass the predicate.");
    return new Refinement(name, type, predicate);
}
exports.refinement = refinement;
//# sourceMappingURL=refinement.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mobx-state-tree/lib/types/utility-types/refinement.js
// module id = 227
// module chunks = 0